import a from "../../requests.js";
import { Catch as i } from "../catch.js";
import { trackingFn as f } from "../../tracker/index.js";
var m = Object.defineProperty, v = Object.getOwnPropertyDescriptor, u = (r, t, o, s) => {
  for (var e = s > 1 ? void 0 : s ? v(t, o) : t, n = r.length - 1, p; n >= 0; n--)
    (p = r[n]) && (e = (s ? p(t, o, e) : p(e)) || e);
  return s && e && m(t, o, e), e;
};
class c {
  constructor(t) {
    this.requests = a(t);
  }
  postEvent(t) {
    const o = {
      ...t,
      meta: {
        ...t.meta,
        event_time: /* @__PURE__ */ new Date()
      }
    };
    return f(this.requests)(o);
  }
}
u([
  i
], c.prototype, "postEvent", 1);
const P = (r) => new c(r);
export {
  P as LocalLogicTracking,
  c as Methods
};
